import dayjs from "dayjs";

export const isWeekend = (date) => date.day() === 0 || date.day() === 6;

// Earliest selectable date: today plus the previous 6 working days (7 working days total), excluding Sat/Sun.
export const getMinWorkingDate = () => {
  let date = dayjs();
  let count = isWeekend(date) ? 0 : 1;

  while (count < 7) {
    date = date.subtract(1, "day");
    if (!isWeekend(date)) {
      count++;
    }
  }
  return date;
};
